module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/video-camera-6d685a4b1485dfe0afaf7c21c6718e10.svg";